import {deleteFalsyKeys} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IOfferListRegion} from "../../offer/types/IOfferListRegion";
import {IPropertyConfiguratorSearchFormValuesType} from "../views/PropertyConfigurator";

interface IAdditionalParams {
    sort?: number | string;
}

export const getPropertyConfiguratorUrl = (values: IPropertyConfiguratorSearchFormValuesType, additionalParams?: IAdditionalParams) => {
    const utm_campaign = values.utm_campaign;
    const utm_content = values.utm_content;
    const utm_id = values.utm_id;
    const utm_medium = values.utm_medium;
    const utm_source = values.utm_source;
    const utm_term = values.utm_term;
    const fbclid = values.fbclid;

    const area_0 = values.area.lower;
    const area_1 = values.area.upper;
    const construction_end_date = values.construction_end_date[0];
    const distance = values.distance;
    const floors = values.floors;
    const kitchen_type = values.kitchen_type;
    let price_0 = values.price.lower;
    let price_1 = values.price.upper;
    const instalment = values.instalment;
    if (instalment && instalment > 0) {
        price_0 = "";
        price_1 = "";
    }
    const rooms_0 = values.rooms.lower;
    const rooms_1 = values.rooms.upper;
    const rooms_area_type_selected = values.rooms_area_type_selected;
    const search = values.search?.regions ? values.search.regions.map((region: IOfferListRegion) => region.id) : null;
    const sort = additionalParams?.sort;
    const world_directions = values.world_directions;

    const newUrl = appendQueryString(rpAppLink.propertyConfigurator(), {
        ...deleteFalsyKeys({
            utm_campaign,
            utm_content,
            utm_id,
            utm_medium,
            utm_source,
            utm_term,
            fbclid,
            area_0,
            area_1,
            construction_end_date,
            distance,
            floors,
            kitchen_type,
            price_0,
            price_1,
            rooms_0,
            rooms_1,
            rooms_area_type_selected,
            search,
            sort,
            world_directions,
            instalment
        })
    });
    return newUrl;
};
import {deleteFalsyKeys} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IOfferListRegion} from "../../offer/types/IOfferListRegion";
import {IPropertyConfiguratorSearchFormValuesType} from "../views/PropertyConfigurator";

interface IAdditionalParams {
    sort?: number | string;
}

export const getPropertyConfiguratorUrl = (values: IPropertyConfiguratorSearchFormValuesType, additionalParams?: IAdditionalParams) => {
    const utm_campaign = values.utm_campaign;
    const utm_content = values.utm_content;
    const utm_id = values.utm_id;
    const utm_medium = values.utm_medium;
    const utm_source = values.utm_source;
    const utm_term = values.utm_term;
    const fbclid = values.fbclid;

    const area_0 = values.area.lower;
    const area_1 = values.area.upper;
    const construction_end_date = values.construction_end_date[0];
    const distance = values.distance;
    const floors = values.floors;
    const kitchen_type = values.kitchen_type;
    let price_0 = values.price.lower;
    let price_1 = values.price.upper;
    const instalment = values.instalment;
    if (instalment && instalment > 0) {
        price_0 = "";
        price_1 = "";
    }
    const rooms_0 = values.rooms.lower;
    const rooms_1 = values.rooms.upper;
    const rooms_area_type_selected = values.rooms_area_type_selected;
    const search = values.search?.regions ? values.search.regions.map((region: IOfferListRegion) => region.id) : null;
    const sort = additionalParams?.sort;
    const world_directions = values.world_directions;

    const newUrl = appendQueryString(rpAppLink.propertyConfigurator(), {
        ...deleteFalsyKeys({
            utm_campaign,
            utm_content,
            utm_id,
            utm_medium,
            utm_source,
            utm_term,
            fbclid,
            area_0,
            area_1,
            construction_end_date,
            distance,
            floors,
            kitchen_type,
            price_0,
            price_1,
            rooms_0,
            rooms_1,
            rooms_area_type_selected,
            search,
            sort,
            world_directions,
            instalment
        })
    });
    return newUrl;
};
